/** Namensähnlichkeit für Tourist-Import Platzzuordnung (entspricht api/core/tourist_import/matching.py). */

function normalizeLabel(value: string): string {
  return value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function tokenSet(value: string): Set<string> {
  return new Set(normalizeLabel(value).split(" ").filter(Boolean));
}

function placeCodeParts(value: string): { prefix: string; num: string } | null {
  const norm = normalizeLabel(value).replace(/\s+/g, "");
  if (!norm) return null;
  const match = /([a-z]*)(\d+)$/.exec(norm);
  if (!match) return null;
  const num = match[2];
  if (!num) return null;
  return { prefix: match[1] ?? "", num };
}

export function similarityScore(a: string, b: string): number {
  const na = normalizeLabel(a);
  const nb = normalizeLabel(b);
  if (!na || !nb) return 0;
  if (na === nb) return 1;
  if (na.includes(nb) || nb.includes(na)) return 0.95;
  const ta = tokenSet(a);
  const tb = tokenSet(b);
  if (ta.size === 0 || tb.size === 0) return 0;
  let overlap = 0;
  for (const t of ta) {
    if (tb.has(t)) overlap += 1;
  }
  const ratio = overlap / Math.max(ta.size, tb.size);
  const prefixBonus = na.slice(0, 3) === nb.slice(0, 3) ? 0.1 : 0;
  return Math.min(1, ratio + prefixBonus);
}

export function placeSimilarityScore(a: string, b: string): number {
  const score = similarityScore(a, b);
  const partsA = placeCodeParts(a);
  const partsB = placeCodeParts(b);
  if (partsA && partsB && partsA.num === partsB.num) {
    if (partsA.prefix === partsB.prefix) return Math.max(score, 1);
    return Math.max(score, 0.92);
  }
  return score;
}

export function sortPitchesByTouristPlanr<T extends { code: string }>(
  pitches: T[],
  touristPlanr: string,
): T[] {
  return [...pitches].sort((a, b) => {
    const diff =
      placeSimilarityScore(touristPlanr, b.code) - placeSimilarityScore(touristPlanr, a.code);
    if (diff !== 0) return diff;
    return a.code.localeCompare(b.code, "de");
  });
}
